<template>
    <div>
        <b-row>
            <b-col md="8">
                <h2 v-if="gridName != ''">{{gridName}}</h2>
                <slot name="gridName" v-if="gridName == ''"></slot>
            </b-col>
            <b-col md="4" class="text-right">
                <slot name="actions"></slot>
            </b-col>
        </b-row>
        <b-table show-empty
                 :items="items? items: getItems"
                 :fields="options.fields"
                 :current-page="options.page"
                 :per-page="options.itemsPerPage"
                 :sort-by.sync="options.sortBy"
                 :sort-desc.sync="options.sortDesc"
                 :sort-direction="options.sortDirection"
                 no-sort-reset
                 table-variant="light"
                 striped
                 bordered
                 :filter="filter"
                 :filter-function="filterFunction"
                 :filter-included-fields="filterIncludedFields"
                 :selectable="selectable"
                 :select-mode="selectMode"
                 @row-selected="onRowSelected"
                 ref="bTable">
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>
            <template v-slot:head(_actions)>
                <span></span>
            </template>
            <template v-slot:head(_selected)="row">
                <!--<input type="checkbox" @change="selectAllRows" v-if="selectMode=='multi'" />-->
                <b-form-checkbox v-model="isCheckAll" @change="selectAllRows" v-if="selectMode=='multi'"></b-form-checkbox>
            </template>
            <template v-slot:cell(_selected)="row">
                <b-form-checkbox v-model="row.rowSelected" @change="selectRow(row)" v-if="isRowSelectable(row.item)"></b-form-checkbox>
            </template>
            <template v-slot:cell(_index)="row">
                {{ getIndex(row) }}
            </template>
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
                <slot :name="slot" v-bind="scope" />
            </template>



            <template v-slot:cell(_collapse)="row">
                <a size="sm" @click="row.toggleDetails" class="mr-2 btn btn-sm" variant="info" v-show="row.item.hasChildren">
                    <span v-if="!row.detailsShowing"><i class="fa fa-caret-right"></i></span>
                    <span v-else><i class="fa fa-caret-down"></i></span>
                    (<span style="font-weight: bold">{{ row.item.chilrenCount }}</span>)
                </a>
            </template>

            <template v-slot:row-details="row">
                <div class="nested-table">
                    <b-grid-tree :gridOptions="gridOptions"
                                 :searchForm="{ parentId: row.item.id, loadChildren: true }"
                                 :nestedIndex="getIndex(row)"
                                 :items="row.item.children"
                                 :dataUrl="dataUrl"
                                 :filter="filter"
                                 :filterFunction="filterFunction"
                                 :filterIncludedFields="filterIncludedFields"
                                 :stickyHeader="false"
                                 :selectable="selectable"
                                 :selectMode="selectMode"
                                 :isRowSelectable="isRowSelectable"
                                 :showIndex="showIndex"
                                 :showActions="showActions"
                                 :onItemDataBound="onItemDataBound"
                                 :paginationNormalize="paginationNormalize"
                                 :resultNormalize="resultNormalize">
                        <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
                            <slot :name="slot" v-bind="scope" v-if="slot !== 'actions'" />
                        </template>
                    </b-grid-tree>
                </div>
            </template>

        </b-table>
        <b-row v-if="totalRows > 0">
            <b-form inline class="col-md-12">
                <b-col md="6">
                    Hiển thị bản ghi từ <b>{{ firstItem }}</b> đến <b>{{ lastItem }}</b> trong tổng số <b>{{ totalRows }}</b> bản ghi
                </b-col>
                <b-col md="6" class="my-1 pull-right input-group">
                    <label class="control-label ml-auto">Kích thước trang</label>
                    <b-form-select v-model="options.itemsPerPage" :options="options.pageOptions" style="flex:none; margin: 0px 5px;"></b-form-select>
                    <b-pagination align="right" :total-rows="totalRows" :per-page="options.itemsPerPage" v-model="options.page" class="my-0" />
                </b-col>
            </b-form>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'BGridTree',
        props: {
            gridOptions: {
                required: true,
            },
            items: {
                type: Array
            },
            nestedIndex: {
                type: String
            },
            dataUrl: {
                type: String,
                //required: true
            },
            filter: {
                type: String
            },
            filterFunction: {
                type: Function
            },
            filterIncludedFields: {
                type: Array
            },
            searchForm: {
            },
            stickyHeader: {
                type: [Boolean, String],
                required: false,
                default: true
            },
            selectable: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            selectMode: {
                type: String,
                default() {
                    return 'multi';
                }
            },
            isRowSelectable: {
                type: Function,
                default: function () {
                    return true;
                },
                required: false
            },
            gridName: {
                type: String,
                required: false
            },
            showIndex: {
                type: Boolean,
                default: true
            },
            showActions: {
                type: Boolean,
                default: true
            },
            onItemDataBound: {
                type: Function,
                required: false
            },
            paginationNormalize: {
                type: Function,
                required: false
            },
            resultNormalize: {
                type: Function,
                required: false
            }
        },
        data() {
            return {
                isBusy: false,
                selectedRows: [],
                isCheckAll: false,
                options: {
                    fields: [],
                    page: 1,
                    itemsPerPage: 10,
                    totalRows: this.items ? this.items.length : 0,
                    pageOptions: [10, 20, 50, 100],
                    sortBy: '',
                    sortDesc: false,
                    sortDirection: 'asc'
                }
            }
        },
        computed: {
            firstItem() {
                return (this.options.page - 1) * this.options.itemsPerPage + 1;
            },
            lastItem() {
                return Math.min(this.totalRows, this.options.page * this.options.itemsPerPage);
            },
            totalRows() {
                if (this.items && this.items.length > 0 && this.$refs.bTable) {
                    return this.$refs.bTable.sortedItems.length;
                } else {
                    return this.options.totalRows;
                }
            }
        },
        created: function () {
            Object.assign(this.options, this.gridOptions);

            if (this.showIndex && this.options.fields.find(x => x.key == '_index') == null) {
                this.options.fields.unshift({ key: '_index', label: 'STT', sortable: false, thAttr: { width: 50 } });
            }

            if (this.showActions && this.options.fields.find(x => x.key == '_actions') == null) {
                this.options.fields.push({ key: '_actions', label: '', sortable: false, thAttr: { width: 70 } });
            }

            var checkboxField = this.options.fields.find(x => x.key == '_selected');
            if (this.selectable && checkboxField == null) {
                this.options.fields.unshift({ key: '_selected', label: '', sortable: false, thAttr: { width: 35 } });
            } else if (!this.selectable && checkboxField != null) {
                this.options.fields.remove(checkboxField);
            }

            this.options.fields.unshift({ key: '_collapse', label: '', sortable: false, thAttr: { width: 10 } });

        },
        methods: {
            getIndex(row) {
                if (this.nestedIndex) {
                    return this.nestedIndex + '.' + ((this.options.page - 1) * this.options.itemsPerPage + row.index + 1);
                } else {
                    return ((this.options.page - 1) * this.options.itemsPerPage + row.index + 1).toString();
                }
            },
            selectAllRows(e) {
                var tbl = this.$refs.bTable;
                if (!this.isCheckAll) {
                    //this.$refs.bTable.selectAllRows();
                    var vm = this;

                    if (tbl.isSelectable && tbl.computedItems.length > 0) {
                        tbl.selectedLastClicked = -1
                        tbl.selectedRows = tbl.selectableIsMultiSelect ? tbl.computedItems.map(item => vm.isRowSelectable(item)) : [true];
                    }

                } else {
                    tbl.clearSelected();
                }
            },
            onRowSelected(items) {
                this.selectedRows = items;
            },
            selectRow(row) {
                if (row.rowSelected) {
                    this.$refs.bTable.unselectRow(row.index);
                } else {
                    this.$refs.bTable.selectRow(row.index);
                }
            },
            getFormData() {
                var pagination;
                if (this.paginationNormalize) {
                    pagination = this.paginationNormalize(this.options)
                } else {
                    pagination = {
                        page: this.options.page,
                        itemsPerPage: this.options.itemsPerPage,
                        sortBy: this.options.sortBy,
                        sortDesc: this.options.sortDesc
                    };
                }

                var formData = $.extend({}, pagination, this.searchForm);

                return formData;
            },
            getItems(ctx) {
                var vm = this;

                var formData = this.getFormData();
                return this.$services.get(this.dataUrl, formData, { showLoading: false }).then((response) => {

                    if (vm.resultNormalize) {
                        return vm.resultNormalize(vm, response);
                    } else {
                        vm.options.totalRows = response.totalRows;

                        if (vm.onItemDataBound && response.data && response.data.length > 0) {
                            response.data.forEach((item) => {
                                vm.onItemDataBound(item);
                            });
                        }
                        return response.data;
                    }
                }, () => []);
            },
            refresh: function () {
                if (this.items && this.items.length > 0) {
                    this.options.totalRows = this.items.length;
                }
                if (this.options.page != 1) {
                    this.options.page = 1;
                } else {
                    this.$refs.bTable.refresh();
                }
            }
        },
        watch: {
            items() {
                this.options.totalRows = this.items.length;
            },
            //showActions() {
            //    if (this.showActions && this.options.fields.find(x => x.key == '_actions') == null) {
            //        this.options.fields.push({ key: '_actions', label: '', sortable: false, thAttr: { width: 70 } });
            //    }

            //    if (!this.showActions && this.options.fields.find(x => x.key == '_actions') != null) {
            //        this.options.fields.remove(this.options.fields.find(x => x.key == '_actions'));
            //    }
            //}
        }
    }
</script>

